import type { ImageTab } from './TabbedImageDisplay';

const PERFORMANCE_REPORTING_IMG = '/admin/img/performance-reporting';

export const BODY_IMAGE_TABS: ImageTab[] = [
  { label: 'Front', imageSrc: `${PERFORMANCE_REPORTING_IMG}/body-front-back.svg`, imageAlt: 'FRONT' },
  { label: 'Back', imageSrc: `${PERFORMANCE_REPORTING_IMG}/body-front-back.svg`, imageAlt: 'BACK' },
];

export const VEHICLE_IMAGE_TABS: ImageTab[] = [
  { label: 'Front', imageSrc: `${PERFORMANCE_REPORTING_IMG}/car-front.svg`, imageAlt: 'FRONT' },
  { label: 'Back', imageSrc: `${PERFORMANCE_REPORTING_IMG}/car-back.svg`, imageAlt: 'BACK' },
  { label: 'Driver', imageSrc: `${PERFORMANCE_REPORTING_IMG}/car-driver.svg`, imageAlt: 'DRIVER' },
  { label: 'Passenger', imageSrc: `${PERFORMANCE_REPORTING_IMG}/car-passenger.svg`, imageAlt: 'PASSENGER' },
  { label: 'Top', imageSrc: `${PERFORMANCE_REPORTING_IMG}/car-top.svg`, imageAlt: 'TOP' },
  { label: 'Undercarriage', imageSrc: `${PERFORMANCE_REPORTING_IMG}/car-undercarriage.svg`, imageAlt: 'UNDERCARRIAGE' },
];
